<vue-server-messages [messages]="messages"></vue-server-messages>
